import React from 'react';
import { Modal, Table } from 'react-bootstrap';
import moment from 'moment';

const formatLabel = (key) => key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

const formatValue = (key, value) => {
    if (value === null || value === undefined || value === '') return '-';
    if (/date|time/i.test(key)) {
        const parsed = moment(value);
        return parsed.isValid() ? parsed.format('MM/DD/YYYY hh:mm A') : value;
    }
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'object') {
        try {
            return JSON.stringify(value);
        } catch (error) {
            return String(value);
        }
    }
    return String(value);
};

const RecordDetailsModal = ({ show, onClose, row }) => {
    const entries = Object.entries(row || {}).filter(([key]) => !/_id$/i.test(key) && key !== 'id' && key !== 'pk');

    return (
        <Modal show={show} onHide={onClose} size="lg" centered scrollable>
            <Modal.Header closeButton>
                <Modal.Title>Record Details</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '65vh', overflowY: 'auto' }}>
                <Table bordered hover striped>
                    <thead style={{ position: 'sticky', top: 0, background: '#f8f9fa', zIndex: 1 }}>
                        <tr>
                            <th style={{ width: '35%' }}>Field</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entries.length > 0
                            ? entries.map(([key, value]) => (
                                <tr key={key}>
                                    <td>{formatLabel(key)}</td>
                                    <td style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{formatValue(key, value)}</td>
                                </tr>
                            ))
                            : (
                                <tr>
                                    <td colSpan={2}>No data found.</td>
                                </tr>
                            )}
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    );
};

export default RecordDetailsModal;
